<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddLang" @submit="formSubmit($event, 'addLang')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addLang',
                    fieldName:'name'
                })"
                :placeholder="$t('enter_the_lang_name')"
                :value.sync="$v.forms.addLang.name.$model"
                :label="$t('name')"

            />
            <CSelect
                :label="$t('langs') + ' (' + $t('optional') + ')' "
                :placeholder="$t('select_a_lang')"
                :options="locales"
                :value.sync="langIdToCopy"
            >
                <template #description>
                    <span>{{ $t('lang_to_copy_description') }}</span>
                </template>
            </CSelect>

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addLang._loading"
            >
                <span>{{ $t('add_lang') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addLang._loading">
                {{ $t("add_lang") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import modalComponentMixin from '~/mixins/modalComponent';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "AddLangModal",
    mixins: [
        formMixin, 
        validationMixin,
        modalComponentMixin
    ],
    components: {
        ButtonLoading
    },
    data(){
        return {
            locales: [],
            langIdToCopy: null,
            forms:{
                addLang:{
                    name: null,
                    translations: {},
                    _loading: false
                },
            }
        }
    },

    validations:{
        forms:{
            addLang:{
                name:{
                    required
                }
            }
        }
    },

    watch:{
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('addLang');
                this.$v.$reset();
            }
        },
        dataComponent(){
            if(this.dataComponent.locales)
                this.locales = this.dataComponent.locales;
        }
    },

    methods:{
        async formSubmit(e, formName){
            e.preventDefault();
            try {
                this.forms.addLang._loading = true;
                if(this.langIdToCopy){
                let data = await this.fetcher({
                        baseURL: process.env.VUE_APP_LANGS_BUCKET,
                        url: this.langIdToCopy + ".json",
                        headers: {
                            "Cache-Control": "no-cache",
                        },
                    });
                    this.forms.addLang.translations = data;
                }
                let response = await this.fetcher({
                    baseURL: process.env.VUE_APP_API_CORE,
                    url: `/langs/${this.forms.addLang.name}`,
                    method: "PUT",
                    data: this.forms.addLang.translations,
                });
                this.forms.addLang._loading = false;
                this.showComponent = false;
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            }
            
            this.$emit('submit',formName);
        },

        executeSubmitForm(){
            this.$refs.formAddLang.requestSubmit();
        }
    }
};
</script>

<style>
</style>